@if (isWarning) {
  <oui-icon class="color-error">report_problem</oui-icon>
}
